import {Component, Input} from '@angular/core';
import {RankScheduleDto} from '../../../../../Models/Rrhh/Schedules/schedule.interface';

@Component({
  selector: 'app-schedule-item',
  templateUrl: './schedule-item.component.html',
  styleUrls: ['./schedule-item.component.scss'],
  standalone: false
})
export class ScheduleItemComponent {
  @Input() item!: RankScheduleDto;
}
